// extracted by mini-css-extract-plugin
export default {"points":"Points_points__cvnaH","points-text":"Points_points-text__TBSuU","receivedPoints":"Points_receivedPoints__XhBsP"};